import React from 'react';
import PropTypes from 'prop-types';
import { noop } from 'lodash-es';
import {
  HEADER_COMPONENT,
  LEAD_FORM_VIEWS,
  LOADING_COMPONENT,
} from 'site-modules/shared/constants/lead-form/lead-form-params';
import { getPriceString } from 'site-modules/shared/utils/price-utils';
import { LeadFormDrawer } from 'site-modules/shared/components/lead-form/lead-form-drawer/lead-form-drawer';
import { WhiteBackButton } from 'site-modules/shared/components/lead-form/lead-form-drawer/close-buttons/white-back-button/white-back-button';
import { BaseEmptyView } from 'site-modules/shared/components/lead-form/unified-lead-form/views/empty-view/base-empty-view';
import { TransparentPricingLeadForm } from 'site-modules/shared/components/lead-form/unified-lead-form-pages/transparent-pricing-lead-form';

const SAVINGS_THRESHOLD = 250;

export function TransparentPricingLeadFormDrawer({
  isOpen = false,
  onDrawerToggle = noop,
  params,
  options,
  creativeId = undefined,
  getLeadFormSrpLinkAttributes = undefined,
  onDrawerHide = undefined,
}) {
  const estimatedSavings = options.coreConfiguration?.estimatedSavings || options.estimatedSavings;
  const headingText =
    estimatedSavings &&
    `Save${estimatedSavings > SAVINGS_THRESHOLD ? ` ${getPriceString(estimatedSavings)}` : ''} with Edmunds`;

  return (
    <LeadFormDrawer
      url=""
      isOpen={isOpen}
      onDrawerToggle={onDrawerToggle}
      component={TransparentPricingLeadForm}
      componentData={{
        params,
        options: {
          loadingComponent: LOADING_COMPONENT.CONVEX,
          leadFormComponent: LEAD_FORM_VIEWS.MODULAR,
          headerComponent: HEADER_COMPONENT.CONVEX,
          thankYouHeaderComponent: HEADER_COMPONENT.CONVEX,
          emptyLeadFormComponent: BaseEmptyView,
          headingText,
          ...options,
          thankYouLayoutOptions: { withConvexHeader: true, ...options.thankYouLayoutOptions },
          getLeadFormSrpLinkAttributes,
        },
      }}
      containerClassName="pos-st"
      drawerContentClassName="bg-cool-gray-90"
      closeBtnComponent={WhiteBackButton}
      dataTrackingParent={creativeId}
      onHide={onDrawerHide}
    />
  );
}

TransparentPricingLeadFormDrawer.propTypes = {
  params: PropTypes.shape({}).isRequired,
  options: PropTypes.shape({}).isRequired,
  isOpen: PropTypes.bool,
  onDrawerToggle: PropTypes.func,
  creativeId: PropTypes.string,
  getLeadFormSrpLinkAttributes: PropTypes.func,
  onDrawerHide: PropTypes.func,
};
